import React from 'react';
import { connect } from 'react-redux';

// components
import {
  Element,
  FontType,
  Align,
  Color,
  Typography,
  Icon
} from '@americanexpress/aqx-components';

// selectors
import { getScrollText, getScrollDownIcon } from '../redux';

// styles
import styles from '../__styles__/scrollDownButton.scss?modules';

const ScrollDownButton = ({ scrollText, imageName, onClick }) => (
  <Element className={styles.buttonContainer}>
    <Element className={styles.buttonText}>
      <Typography
        $family={FontType.BentonBold}
        $size={16}
        theme={{
          textAlign: Align.Center,
          color: Color.White,
          marginTop: 0,
          marginBottom: 0
        }}
      >
        {scrollText}
      </Typography>
    </Element>
    <Element
      Component="button"
      className={styles.iconContainer}
      onClick={onClick}
      qeId="scroll-down-button"
      role="button"
      aria-label={scrollText}
      tabIndex={0}
    >
      <Icon
        directory="dls"
        imageName={imageName}
        theme={{ color: Color.White }}
        hiddenToScreenReaders={true}
      />
    </Element>
  </Element>
);

const mapStateToProps = state => ({
  scrollText: getScrollText(state),
  imageName: getScrollDownIcon(state)
});

export default connect(mapStateToProps)(ScrollDownButton);
